import { render, staticRenderFns } from "./Aggregators.vue?vue&type=template&id=b2f930f0&"
import script from "./Aggregators.vue?vue&type=script&lang=js&"
export * from "./Aggregators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports